export default [
    {
        path: "/view/guardian/",
        name: "Guardian",
        component: () => import ("@/layout/full/MainContainer.vue"),
        children: [
            {
                path: "manage-person/generalinformation",
                name: "Formulario de Registro de usuario",
                component: () => import ("@/views/guardian/manage-tenant/GeneralInformation")
            }
        ]
    },
    {
        path: "/view/guardian/manage-person/registration",
        name: "Registrar Persona",
        component: () => import ("@/views/guardian/manage-tenant/GeneralInformation")
    },

];

